/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: authoring-common
 * (C) Copyright IBM Corp. 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class PalettePicker extends Component {

	// just a guesstimate of what it will need for now, based on ChangePaletteView options
	static propTypes = {
		paletteService: PropTypes.object.isRequired, // was glass context
		getPalettes: PropTypes.func.isRequired,
		onCreatePalette: PropTypes.func.isRequired,
		onChange: PropTypes.func.isRequired,
		mruComponentIdentifier: PropTypes.string.isRequired, // was component
		selectedId: PropTypes.string,
		createPaletteType: PropTypes.string
	};

	render() {
		return (
			<div>
				Palette Picker Placeholder
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/js/dialog/PalettePicker.js